module.exports = __webpack_public_path__ + "img/1479.125f8e77.png";